module.exports = __webpack_public_path__ + "images/logo.6d967c.svg";